import { useRouter } from 'next/router';

import { web_path } from '@common/constants';
import { Dialog } from '@common/overlay-manager';

import { AuthInfo, AuthSessionStorage } from '../utils';
import { useSocialAccountError } from './useSocialAccountError';

export const useLoginErrors = () => {
  const { push, replace } = useRouter();
  const { checkPasswordExisted } = useSocialAccountError();

  const moveToSignUpPage = (auth_info: AuthInfo) => {
    const url = web_path.auth.terms_agreement;
    AuthSessionStorage.saveAuthInfo(auth_info);
    push(url);
  };

  const moveToWriteEmailPage = (auth_info: AuthInfo) => {
    AuthSessionStorage.saveAuthInfo(auth_info);
    push(`${web_path.auth.write_email}?is_social_account=true`);
  };

  const moveToConnectAccountPage = (error: any, auth_info: AuthInfo) => {
    const error_code = error?.extensions?.code;
    const has_password = error?.extensions?.has_password ?? true;
    const connected_social_account = {
      kakao_connected: error?.extensions?.kakao_connected,
      facebook_connected: error?.extensions?.facebook_connected,
      google_connected: error?.extensions?.google_connected,
      apple_connected: error?.extensions?.apple_connected,
      toss_connected: error?.extensions?.toss_connected,
    };
    AuthSessionStorage.saveAuthInfo(auth_info);
    AuthSessionStorage.saveEmail(error?.extensions?.email ?? '');
    checkPasswordExisted({
      type: auth_info.type,
      has_password,
      email: error?.extensions?.email ?? '',
      connected_social_account,
      is_masked_email: error_code === 'user_account_mobile_tel_exists',
    });
  };

  const checkLoginError = (error: any, auth_info: AuthInfo) => {
    const error_code = error?.extensions?.code;

    if (error_code === 'user_account_not_found') {
      moveToSignUpPage(auth_info);
      return;
    }

    if (error_code === 'user_account_email_exists' || error_code === 'user_account_mobile_tel_exists') {
      moveToConnectAccountPage(error, auth_info);
      return;
    }

    if (error_code === 'user_account_invalid_email') {
      moveToWriteEmailPage(auth_info);
      return;
    }

    /** 사용자계정이 비활성화 계정인 경우 */
    if (error_code === 'auth_inactive_user_account' || error_code === 'inactive_user_account') {
      Dialog.alert({ message: '비활성화 또는 휴면 계정입니다. 다른 계정으로 로그인 해주세요.' });
      if (auth_info.type === 'kakao') {
        replace(web_path.auth.login);
      }
      return;
    }

    Dialog.alert({
      type: 'warning',
      title: '문제가 생겼어요',
      message: '잠시 후 다시 시도해주세요.\n문제가 지속되면 고객센터로 문의해주세요.',
    });
  };

  return { checkLoginError };
};
